<template>
  <span
    :class="{ 'release-type-album': type === 'album', 'release-type-single': type === 'single' }"
    class="release-type-label">
    {{ type === 'album' ? 'アルバム配信' : 'シングル配信' }}
  </span>
</template>

<script>
export default {
  name: 'ReleaseTypeLabel',
  props: {
    type: {
      type: String,
      required: false,
      default: () => 'album',
    },
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped>
  .release-type-label {
    position: absolute;
    right: 20px;
    height: 35px;
    width: 120px;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    color: white;
    padding: 7px 0 2px 0;
    margin: 0px;
  }
  @media screen and (max-width: 895px) {
  .release-type-label {
    position: absolute;
    right: 10px;
    height: 30px;
    width: 75px;
    font-weight: bold;
    font-size: 10px;
    text-align: center;
    color: white;
    padding: 7px 0 2px 0;
    margin: 0px;
    }
  }
  .release-type-album {
    background-color: #3bc88a;
  }
  .release-type-single {
    background-color: #4bc1f2;
  }
</style>
